import { BrandingSectionFormErrorJSON } from '../models/branding-section';

export const formBrandingSectionErrors: BrandingSectionFormErrorJSON = {
    favIconURL: [
        {
            code: 'pattern',
            message: 'Invalid URL',
        },
    ],
    mainLogoLightUrl: [
        {
            code: 'pattern',
            message: 'Invalid URL',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    mainLogoDarkUrl: [
        {
            code: 'pattern',
            message: 'Invalid URL',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    mainLogoWidth: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    mainLogoHeight: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    alternativeLogoLightUrl: [
        {
            code: 'pattern',
            message: 'Invalid URL',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    alternativeLogoDarkUrl: [
        {
            code: 'pattern',
            message: 'Invalid URL',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    alternativeLogoWidth: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    alternativeLogoHeight: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
